import React, { useCallback, useState, useEffect } from "react"

export function useLocalStorage(key, defaultValue) {
    return useStorage(key, defaultValue, window.localStorage)
}

export function useSessionStorage(key, defaultValue) {
    return useStorage(key, defaultValue, window.sessionStorage)
}

function useStorage(key, defaultValue, storageObject) {
    const [value, setValue] = useState(() => {
        try {
            const jsonValue = storageObject.getItem(key)
            if (jsonValue != null) {
                return JSON.parse(jsonValue)
            }
        } catch (error) {
            console.error(`Error reading storage key "${key}":`, error)
            // Clean up corrupted data
            try {
                storageObject.removeItem(key)
            } catch (removeError) {
                console.error(`Error removing corrupted storage key "${key}":`, removeError)
            }
        }

        if (typeof defaultValue === "function") {
            return defaultValue()
        } else {
            return defaultValue
        }
    })

    useEffect(() => {
        try {
            if (value === undefined) {
                storageObject.removeItem(key)
            } else {
                storageObject.setItem(key, JSON.stringify(value))
            }
        } catch (error) {
            console.error(`Error setting storage key "${key}":`, error)
        }
    }, [key, value, storageObject])

    const remove = useCallback(() => {
        setValue(undefined)
    }, [])

    return [value, setValue, remove]
}